var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Inactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 13.4139C24 20.5574 18.6274 26.3484 12 26.3484C5.37258 26.3484 0 20.5574 0 13.4139C0 6.27045 5.37258 0.479507 12 0.479507C18.6274 0.479507 24 6.27045 24 13.4139Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13_1760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.71 7.71201C14.32 7.29164 13.69 7.29164 13.3 7.71201L8.70998 12.6594C8.31998 13.0798 8.31998 13.7588 8.70998 14.1792L13.3 19.1266C13.69 19.547 14.32 19.547 14.71 19.1266C15.1 18.7063 15.1 18.0272 14.71 17.6068L10.83 13.4139L14.71 9.2318C15.1 8.81143 15.09 8.1216 14.71 7.71201V7.71201Z",
    fill: "#323232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.8689,
    fill: "white",
    transform: "translate(0 0.479507)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_1760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.8689,
    fill: "white",
    transform: "translate(0 0.479507)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Inactive);
export default __webpack_public_path__ + "static/media/01. Inactive.6f35657fecd75df081c6444204899226.svg";
export { ForwardRef as ReactComponent };